<pivot-modal-template class="ds-modal form-modal" [modalTemplate]="modalTemplate"
    (closeModalHandler)="closeFormModal()">
    <div class="ds-modal-body" modal-body>
        <div class="row">
            <label>{{BUTTON.DATASOURCE_SELECT}}</label>
        </div>
        <div class="searchbar-container">
            <pivot-search-bar [searchParams]="searchParams" (onFilterData)="onFilterOutData($event)"></pivot-search-bar>
            <label>{{COMMON_TEXT.ITEM}}</label>
        </div>
        <div class="ds-tree-row">
            <div class="ds-tree-container">
                <pivot-tree-view (isOnFetchData)="handleNodeFetchProcess($event)" [isTemplate]="isTemplate" [params]="datasourceTreeData2Level" (nodeMouseClick)="handleNodeClick($event)">
                </pivot-tree-view>

                <div *ngIf="showNoDataText()" class="tree-view-placeholder">{{COMMON_TEXT.NO_DATA}}</div>
            </div>
            <pivot-list-box [params]="lbParams" class="ds-list-box"></pivot-list-box>
        </div>
    </div>
    <div class="ds-modal-bottom" modal-bottom>
        <div class="right-pannel">
            <pivot-text-button (btnClick)="cancel()" [buttonType]="buttonType.SECONDARY" [buttonText]="BUTTON.CANCEL">
            </pivot-text-button>
            <pivot-text-button [disabled]="disableSaveCheck()" (btnClick)="save()" [buttonType]="buttonType.SECONDARY" [buttonText]="BUTTON.SELECT">
            </pivot-text-button>
        </div>
    </div>
</pivot-modal-template>